module.exports = __webpack_public_path__ + "img/zsgj_common.fd0f5a55.png";